import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import httpRequest from 'src/helpers/httpRequest';
import { IPaginated } from 'src/types/paginated';
import qs from "qs";
import { truncateString } from 'src/helpers/helperFunctions';
import IsFavoriteComponent from '../Customer/ProductsAndServicesComponents/IsFavoriteComponent';
import PaginationComponet from '../GlobalComponents/PaginationComponet';
import { CircularProgress } from '@mui/material';
import AddCartComponent from 'src/Components/Customer/ProductsAndServicesComponents/AddCartComponent';
import { Link } from 'react-router-dom';
import CounterComponent from '../Customer/ProductsAndServicesComponents/CounterComponent';
import wishlistIcon from 'src/assets/images/no-wishlist-icon.png'
import { CURRENCY } from 'src/lib/constans';

interface IObj {
    _id: string;
    productName: string;
    image: string;
    price: number;
    salePrice: number;
    brandsName: string;
    shortDescription: string;
    isLiked: boolean;
    prescriptionRequired: boolean;
};

interface IResponse {
    documents: IObj[];
    paginated: IPaginated;
};

const FavPharma: React.FC = () => {
    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [data, setData] = useState<IObj[]>([]);
    const [paginated, setPaginated] = useState<IPaginated>({
        currentPage: 1,
        totalPages: 1,
    });
    const [queryParams, setQueryParams] = useState<{ page: number; limit: number; bool: boolean; }>({
        page: 1,
        limit: 10,
        bool: false,
    });

    const handleRemove = (obj: { productId: string; }) => {
        if (data?.length > 1) {
            setData(prev => prev?.filter(v => v._id !== obj?.productId));
        } else {
            setQueryParams(prev => ({
                ...prev,
                bool: !prev.bool,
                page: prev?.page > 1 ? prev?.page - 1 : prev?.page
            }));
        }
    };
    const fetch = async () => {
        setIsLoader(true);
        const { bool, ...actulaParams } = queryParams;
        const { res, err } = await httpRequest<IResponse>({ path: `/inventory-favproduct/fav-pharma-products?${qs.stringify(actulaParams)}` });
        if (res) {
            setData(res?.documents || []);
            setPaginated(res?.paginated);
        } else {
            toast(err, { type: "error" });
        }
        setIsLoader(false);
    };
    useEffect(() => {
        fetch();
    }, [queryParams]);

    const PrintItem: React.FC<{ item: IObj }> = ({ item }) => {
        const [count, setCount] = useState<number>(1);
        return (
            <div key={item?._id} className="my-list-dashbaord">
                <div className='my-list-dashbaord-left'>
                    <img src={`${item?.image}`} alt="" />
                </div>
                <div className='customer-pharmacy-card-content-text'>
                    <div className='flex items-start justify-between'>
                        <div>
                            <span className='font-Poppins-Medium font-size-16px theme-color-green'>{truncateString(item?.brandsName || "", 20)}</span>
                            <Link to={`/customer/pharmacy-product-detail/${item?._id}/view`} className='font-Poppins-SemiBold mb-1 font-size-18px text-[#4F6367] block underline'>{truncateString(item?.productName || "", 40)}</Link>
                            <p className='font-Poppins-Medium w-[90%] font-size-16px text-[#707070]'>{truncateString(item?.shortDescription || "", 100)}</p>
                        </div>
                        <IsFavoriteComponent
                            category="pharmacy"
                            onSuccess={handleRemove}
                            productId={item?._id}
                            isFav={item?.isLiked || false}
                        />
                    </div>
                    <div className='my-list-data-price mt-0 mb-2'>
                        <strong className='font-size-20px font-Poppins-Bold theme-color-green'>{CURRENCY} {item?.salePrice || item?.price}</strong>
                        {item?.salePrice != null && item?.salePrice > 0 && (
                            <strong className='font-size-20px line-through font-Poppins-Regular text-[#878787]'>{`${item?.price || "-"}`}</strong>
                        )}
                    </div>
                    <div className='flex justify-between items-center'>
                        <CounterComponent
                            type="pharmacy"
                            productId={item?._id}
                            updateCount={(val: number) => setCount(val)}
                        />
                        <div>

                            <AddCartComponent
                                textBtn={true}
                                productId={item?._id}
                                type="pharmacy"
                                prescriptionRequired={item?.prescriptionRequired || false}
                                quantity={count || 1}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    return (
        <div className="my-list-dashbaord-main">
            {isLoader ?
                <div className='flex justify-center mt-6'>
                    <CircularProgress style={{ width: 24, height: 24, color: "#00443f" }} />
                </div>
                : data?.length ?
                    data?.map(item => (
                        <PrintItem
                            key={item?._id}
                            item={item}
                        />
                    ))
                    :
                    <div className='parchi-icon-order'>
                        <img src={wishlistIcon} alt="" />
                        <span className="text-center font-Poppins-Medium font-size-22px">No Pharma Products in the list</span>
                    </div>
            }

            {paginated?.totalPages > 1 &&
                <PaginationComponet
                    total={paginated.totalPages}
                    currentPage={paginated.currentPage}
                    setCurrentPage={(_page) => setQueryParams(prev => ({ ...prev, page: _page }))}
                />
            }
        </div>
    );
};

export default FavPharma;